export const CONTACT_EMAIL = "info@algermanist.com";
export const RECRUITMENT_EMAIL = "theresa.dietrich@algermanist.com";
